// import './components/styles/_styles.scss'
// import Header from './components/UI/Header/Header.jsx'
// import Home from './components/UI/Home/Home.jsx'
import React from "react";
import Routes from "./components/routes.jsx";
import Modal from "./components/Modal/Modal.jsx";

function App() {



  return <Routes />;
}

export default App;
